const plugins = {};
export function getPlugins() {
  return { ...plugins
  };
}
export function addPlugin(newPlugins) {
  for (const [name, plugin] of Object.entries(newPlugins)) {
    if (!plugin) {
      delete plugins[name];
    } else {
      plugins[name] = plugin;
    }
  }
}